import { useCallback } from "react";
import { Redirect } from "react-router-dom";
import { home } from "@newRoutes/home/Index";
import { useRefreshSession } from "@newHooks/auth/useRefreshSession";
import { useSignOut } from "@newHooks/auth/useSignOut";
import { useSessionContext } from "@newHooks/context/session/session.context";
import { Session } from "./libs/common";
import { SSO } from "./SSO";

const auth = {
  index: "/auth",
} as const;

const ssoBaseUrl = process.env.REACT_APP_SSO_FE_URL;
const defaultRedirect = home.index;

export function Auth() {
  const { session } = useSessionContext();
  const refreshSession = useRefreshSession();
  const signOut = useSignOut();

  const handleSessionCreated = useCallback(
    (session: Session, redirectTo: string) => {
      refreshSession(session, { redirectTo });
    },
    [refreshSession]
  );

  const handleDecryptSessionError = useCallback(() => {
    signOut({ redirectTo: auth.index });
  }, [signOut]);

  const handleSessionExpired = useCallback(() => {
    signOut({ redirectTo: auth.index });
  }, [signOut]);

  if (session) {
    return <Redirect to={defaultRedirect} />;
  }

  return (
    <SSO
      ssoBaseUrl={ssoBaseUrl!}
      defaultRedirect={defaultRedirect}
      onSessionCreated={handleSessionCreated}
      onSessionExpired={handleSessionExpired}
      onDecryptSessionError={handleDecryptSessionError}
    />
  );
}
